import axios from 'axios'
import { useEffect } from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import * as Redux from 'redux'
import LayoutLoading from './layouts/LayoutLoading/LayoutLoading'
import AuthAction from './store/auth/auth.action'

interface IConfiguration {
    logout?: () => void
}

function Configuration(props: IConfiguration) {
    const { logout } = props
    const history = useHistory()
    useEffect(() => {
        // check user authorize (API)
        axios.interceptors.response.use(
            (response: any) => {
                return Promise.resolve(response)
            },
            (errors: any) => {
                // const statusCode = errors?.response?.data?.statusCode;
                const message = errors?.response?.data?.message
                if (
                    message === 'Unknown User' ||
                    message === 'TokenExpiredError jwt expired'
                ) {
                    if (logout) logout()
                    history?.push('/')
                }
                return Promise.reject(errors)
            }
        )
    }, [])

    return (
        <>
            <LayoutLoading />
            <ToastContainer />
        </>
    )
}

// store section

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    const { logout } = AuthAction
    return {
        logout: () => dispatch(logout() as any),
    }
}

export default connect(null, mapDispatchToProps)(Configuration)
